var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('thead',{class:_setup.header({ ..._setup.props, ..._setup.rootProps }),attrs:{"data-component":"CsTableHeader"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }